import { combineReducers } from 'redux';
import { FetchProducts, FetchCyoaProducts, SaveProduct } from './reducer_product';
import { FetchCurrency, SaveCurrency } from './reducer_currency';
import { FetchContentful } from './reducer_contentful';
import { Sequence, Sequences } from './reducer_sequence';
import { FetchCities } from './reducer_cities';
import { FetchInfo, FetchFullInfo } from './reducer_info';
import { Destinations } from './reducer_destination';
import { BuilderList, BuilderSequence } from './reducer_builder';
import { FetchSequenceCapacity, FetchLiveCapacity, FetchCapacity, FetchEditCapacity  } from './reducer_capacity';
import { FetchItineraries } from './reducer_itineraries';
import { ToggleModal } from './reducer_modal';
import { reducer as formReducer } from 'redux-form';
import { /*SaveErrors,*/ FetchErrors } from './reducer_errors';
import { /*SaveNationality,*/ FetchNationality } from './reducer_nationality';
import { CurrentBooking, BookingGroup } from './reducer_booking';
import { FetchDiscount } from './reducer_discount';


const rootReducer = combineReducers({
  editDaysCapacity:FetchEditCapacity,
  itineraries:FetchItineraries,
  fullInfo:FetchFullInfo,
  toggleModal:ToggleModal,
  sequenceCapacity:FetchSequenceCapacity,
  form:formReducer,
  // errorMessages:SaveErrors,
  errorMessages:FetchErrors,
  nationality:FetchNationality,
  // nationality:SaveNationality,
  product:SaveProduct,
  currentBooking:CurrentBooking,
  bookingGroup:BookingGroup,
  capacity:FetchCapacity,
  liveCapacity:FetchLiveCapacity,
  discount:FetchDiscount,
  contentful:FetchContentful,
  currencyInfo:SaveCurrency,
  products:FetchProducts,
  info:FetchInfo,
  cities:FetchCities,
  currency:FetchCurrency,
  sequences:Sequences, //MULTIPLE SEQUENCE
  sequence:Sequence, //SINGLE SEQUENCE
  cyoaProducts:FetchCyoaProducts,
  destinations:Destinations,
  builderSequence:BuilderSequence,
  builderlist:BuilderList
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js